import { Center, Flex } from '@chakra-ui/react';
import { AddPulsIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface IsContactsProps {
  onBlock?: () => Promise<void>;
  onAddContacts?: () => Promise<void>;
}

function IsContacts({ onAddContacts }: IsContactsProps) {
  const { t } = useTranslation();
  // const [loadingBlock, setLoadingBlock] = useState(false);
  const [loadingAddContacts, setLoadingAddContacts] = useState(false);

  // const handleBlock = useCallback(async () => {
  //   if (loadingBlock) return;
  //   setLoadingBlock(true);
  //   await onBlock?.();
  //   setLoadingBlock(false);
  // }, [loadingBlock, onBlock]);

  const handleAddContacts = useCallback(async () => {
    if (loadingAddContacts) return;
    setLoadingAddContacts(true);
    await onAddContacts?.();
    setLoadingAddContacts(false);
  }, [loadingAddContacts, onAddContacts]);

  return (
    <Flex p="3.5" fontSize="sm">
      {/* <Flex flex="1" alignItems="center" justifyContent="center">
        <Flex
          onClick={handleBlock}
          alignItems="center"
          justifyContent="center"
          gap="1"
          cursor="pointer"
          color="fg"
          _hover={{
            color: 'fg',
          }}
        >
          <Center fontSize="lg">
            <BlockIcon />
          </Center>
          Block
        </Flex>
      </Flex>
      <Separator orientation="vertical" borderColor="border.muted" /> */}
      <Flex flex="1" alignItems="center" justifyContent="center">
        <Flex
          onClick={handleAddContacts}
          cursor="pointer"
          color="fg"
          _hover={{
            color: 'fg',
          }}
          alignItems="center"
          justifyContent="center"
          gap="1"
        >
          <Center fontSize="lg">
            <AddPulsIcon />
          </Center>
          {t('action.addContact')}
        </Flex>
      </Flex>
    </Flex>
  );
}

const MemoizedIsContacts = memo(IsContacts);

export { MemoizedIsContacts as IsContacts };
